import React, { useEffect } from 'react'
import { useRouter } from 'next/router'

import EditPengembanganKompetensiApp from 'app/KinerjaPage/pages/Pelaksanaan/PengembanganKompetensi/Edit'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerja'
import ContentProvider from 'app/KinerjaPage/components/ContentProvider'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'
import { useNewDocumentFlow } from 'app/KinerjaShared/hooks/useNewDocumentFlow'
import { NotFoundError } from 'utils/customError'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'
import type { Jenjang } from 'types/kinerja'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return { props: {} }
  },
})

const EditPengembanganKompetensi = () => {
  const { data: { data: skp } = {}, isFetched: isSKPFetched } = useAPIKinerja()
  const router = useRouter()

  const { status } = useNewDocumentFlow()

  if (status === 'DISABLED') {
    throw new NotFoundError('', 'Not Found')
  }

  useEffect(() => {
    if (isSKPFetched && skp?.status !== 'READY') {
      router.back()
    }
  }, [isSKPFetched, skp?.status, router])

  return (
    <PageGuardPelaksanaanDate>
      <ContentProvider jenjang={skp?.jenjang as Jenjang}>
        <EditPengembanganKompetensiApp skp={skp} isSKPFetched={isSKPFetched} />
      </ContentProvider>
    </PageGuardPelaksanaanDate>
  )
}

EditPengembanganKompetensi.Layout = KinerjaLayout

EditPengembanganKompetensi.layoutOpts = {
  hasHeader: true,
}

export default EditPengembanganKompetensi
